export class ResponseManagement {
    contactUs: Contactus = new Contactus();
    storeFeedBack: StoreFeedBack = new StoreFeedBack();
    riderDiscrepency: RiderDiscrepency = new RiderDiscrepency();
    whatsApp: WhatsApp = new WhatsApp();
}

export class Contactus {
    inProcess: number = 0;
    resolved: number = 0;
    total: number = 0;
    unResolved: number = 0;
}

export class StoreFeedBack {
    inProcess: number = 0;
    resolved: number = 0;
    total: number = 0;
    unResolved: number = 0;
}

export class RiderDiscrepency {
    inProcess: number = 0;
    resolved: number = 0;
    total: number = 0;
    unResolved: number = 0;
}

export class WhatsApp {
    inProcess: number = 0;
    notResponded: number = 0;
    total: number = 0;
    responded: number = 0;
}
